module.exports = __webpack_public_path__ + "img/@tmp_course_thumbnail_03.a341108a.jpg";